import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { AuthUser } from '@/types/auth';

export const useAuthRedirect = (isLoggedIn: AuthUser | null) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const from = location.state?.from?.pathname || '/home';
      navigate(from, { replace: true });
    }
  }, [isLoggedIn, navigate, location]);
};
